import { render } from "./bank-pencil-icon.vue.js?vue&type=template&id=c04439ee!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./bank-pencil-icon.vue?vue&type=template&id=c04439ee"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__